export interface IBackButtonState {
  params: any;
}

export const initialBackButtonState: IBackButtonState = {
  params: null,
};
